import { CircularProgress, Grid } from '@material-ui/core';
import { type ReactNode } from 'react';

interface Props {
	isLoading: boolean;
	children: ReactNode;
}

export function Loading({ children, isLoading }: Props) {
	return (
		<Grid container>
			{isLoading ? (
				<Grid
					alignItems={'center'}
					container
					item
					justify={'center'}
					style={{ height: 500 }}
				>
					<CircularProgress color={'secondary'} />
				</Grid>
			) : (
				children
			)}
		</Grid>
	);
}
